export default __webpack_public_path__ + "static/creativefx-2-bg-1cb8211417f0357205903e0f5e7bcdbb.png";